import { DictionaryType, IDictionaryValue } from '@common/dictionaries';

// группы данных мониторинга
export const MonitoringDataGroup = {
  InvestmentExpenses: 'investment-expenses',
  OperatingBusiness: 'operating-business',
  ProjectFinancing: 'project-financing',
} as const;

export type MonitoringDataGroup = (typeof MonitoringDataGroup)[keyof typeof MonitoringDataGroup];

export const MonitoringFinanceComparison = {
  FinanceSalesComparisonRetrieve: 'finance_sales_comparison_retrieve',
  FinanceProfitLossComparisonRetrieve: 'finance_profit_loss_comparison_retrieve',
  FinanceCashFlowComparisonRetrieve: 'finance_cash_flow_comparison_retrieve',
  FinanceBalanceComparisonRetrieve: 'finance_balance_comparison_retrieve',
  FinanceCoefficientsComparisonRetrieve: 'finance_coefficients_comparison_retrieve',
} as const;

export type MonitoringFinanceComparison =
  (typeof MonitoringFinanceComparison)[keyof typeof MonitoringFinanceComparison];

/** тип данных параметра Период - "month", "year" */
export type MonitoringFinanceComparisonPeriod = 'month' | 'year' | undefined;

// типы данных мониторинга
export enum MonitoringDataType {
  capex = 'capex',
  sales = 'sales',
  expenses = 'expenses',
  taxes = 'taxes',
  purchases = 'purchases',
  attachments = 'attachments',
  credits = 'credits',
  leasings = 'leasing',
}

/** Типы справочников (enums) доступные в модуле мониторинга
 *
 * api/monitoring/common/enums
 */
export enum MonitoringDictionaryType {
  ExpenseActivityClassification = 'expense_activity_classification_choices',
  ExpenseClassification = 'expense_classification_choices',
  ExpenseType = 'expenses_type',
  CreditPayment = 'credit_payment_choices',
  LeasingPayment = 'leasing_payment_choices',
  Tax = 'tax_type_choices',
  CreditType = 'credit_type_choices',
  ObjectType = 'object_type_choices',
  PaymentType = 'payment_type_choices',
  BaseCalculationDeal = 'base_calculation_deal_choices',
  PersonnelType = 'personnel_type_choices',
  IndexingFrequency = 'indexing_frequency_choices',
  // NOTE: оплата труда
  // PersonnelTypes = 'personnel_types',
}

/** Периоды получения данных метрик */
export const MonitoringChartPeriod = {
  Month: 'month',
  Year: 'year',
} as const;

export type MonitoringChartPeriod = (typeof MonitoringChartPeriod)[keyof typeof MonitoringChartPeriod];
/**
 * @description кода-значения вариантов отображения данных мониторинга на графике
 */
export const MonitoringChartType = {
  Bar: 'bar',
  Line: 'line',
} as const;

export type MonitoringChartType = (typeof MonitoringChartType)[keyof typeof MonitoringChartType];

/** Локализованные справочники для мониторинга */
export class MonitoringDictionary extends DictionaryType {
  constructor(code: string, values: IDictionaryValue[]) {
    super(code, values);
  }
}
